import { CaretDownOutlined, CaretUpOutlined, FilterOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { Moment } from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ContainerTable,
  CustomHeaderTable,
  DataCellWrapper,
  EffortWrapper,
  HeaderCelDate,
  HeaderCellWrapper,
  HeaderCellWrapperCustom,
  TableCustom,
  TableWrapper,
  Wrappertable,
} from '@/components/pages/ClientDevice/styles'
import { GetAttendanceEmployeeByDayResponse } from '@/types/apis/attendanceEmployee'
import { formatDateSendRequest, formatYMD } from '@/utils/date'
import { getName } from '@/utils/employee'

type Props = {
  responseAttendanceEmployee?: GetAttendanceEmployeeByDayResponse
  responseAttendanceEmployeeLoading?: boolean
  dateFilter?: Moment | null
  employeeFilter: boolean
  handleFilterEmployee: () => void
}

const AttendanceEmployeeByDayTable = ({
  responseAttendanceEmployee,
  responseAttendanceEmployeeLoading,
  dateFilter,
  employeeFilter,
  handleFilterEmployee,
}: Props) => {
  const { t } = useTranslation()
  const dataSource = responseAttendanceEmployee?.employees ?? []
  const dataAttendance = responseAttendanceEmployee?.clientDevices ?? []

  return (
    <ContainerTable>
      <Spin spinning={responseAttendanceEmployeeLoading}>
        <TableWrapper>
          <EffortWrapper>{t('components.pages.attendanceEmployee.listReport.table.hour')}</EffortWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <CustomHeaderTable>
                  <HeaderCelDate>{t('components.pages.attendanceEmployee.listReport.table.date')}</HeaderCelDate>
                  <HeaderCellWrapperCustom onClick={handleFilterEmployee}>
                    {t('components.pages.attendanceEmployee.listReport.table.id')}
                    <FilterOutlined style={{ marginLeft: 10 }} />
                    {employeeFilter ? (
                      <CaretUpOutlined style={{ marginLeft: 3 }} />
                    ) : (
                      <CaretDownOutlined style={{ marginLeft: 3 }} />
                    )}
                  </HeaderCellWrapperCustom>
                  <HeaderCellWrapper>
                    {t('components.pages.attendanceEmployee.listReport.table.fullName')}
                  </HeaderCellWrapper>
                  {dataAttendance?.map((item, index) => (
                    <HeaderCellWrapper key={index}>{item.name}</HeaderCellWrapper>
                  ))}
                  <HeaderCellWrapper>
                    {t('components.pages.attendanceEmployee.listReport.table.total')}
                  </HeaderCellWrapper>
                </CustomHeaderTable>
                {dateFilter &&
                  dataSource.map((employee, index) => (
                    <tr key={index}>
                      <DataCellWrapper>{formatYMD(formatDateSendRequest(dateFilter))}</DataCellWrapper>
                      <DataCellWrapper>{employee.id}</DataCellWrapper>
                      <DataCellWrapper position={'left'}>{getName(employee)}</DataCellWrapper>
                      {dataAttendance?.map((clientDevice, index) => (
                        <DataCellWrapper key={index}>
                          {employee.attendances
                            ?.find((attendance) => attendance.clientDeviceId === clientDevice.id)
                            ?.workingTime.toFixed(1)}
                        </DataCellWrapper>
                      ))}
                      <DataCellWrapper>
                        {employee.totalWorkingTime ? employee.totalWorkingTime.toFixed(1) : undefined}
                      </DataCellWrapper>
                    </tr>
                  ))}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
AttendanceEmployeeByDayTable.displayName = 'AttendanceEmployeeByDayTable'
export default AttendanceEmployeeByDayTable
